import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation } from "react-router-dom";

interface Props {
  lastKey: string;
}

export const BackButton = ({ lastKey }: Props) => {
  const location = useLocation();

  return (
    <Link to={location.pathname.replace(lastKey, "")}>
      <div className="inline-flex flex-row gap-4 bg-gray-300 hover:bg-gray-400 m-2 py-2 px-4 rounded-lg ">
        <span className="text-xl ">
          <FontAwesomeIcon icon={faArrowLeft} />
        </span>

        <span className="text-xl font-medium">Back</span>
      </div>
    </Link>
  );
};
